// side effect: fetch new price calculation when decisions are made
import {fetchExplanations} from '../slices/decisionsSlice';

export const explainMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'decisions/decision/fulfilled' || action.type === 'decisions/decisionsLoading/fulfilled') {
        if (store.getState().session.sessionId !== null && store.getState().status.family !== 'Aeto') {
            // after decision(s), get all Explanations
            store.dispatch(fetchExplanations());
        }
    }
    return result;
};
